/* eslint-disable react/prop-types */

import React from 'react';
import HashtagRow from './hashtag_row';

function HashtagTable({
  hashtags,
  hashtagUsageCeiling,
  onFollow,
  onMute,
  onBlock,
  onRemoveForceFollow,
  emptyMessage = 'No hashtags found in this list.',
}) {
  if (hashtags.length === 0) {
    return <div className="alert mt-2 mb-0">{emptyMessage}</div>;
  }

  return (
    <div className="table-responsive">
      <table className="table hashtag-table table-hover mb-0">
        <thead>
          <tr>
            <th>Hashtag</th>
            <th>Volume</th>
            <th className="text-end pe-5">Status</th>
          </tr>
        </thead>
        <tbody>
          {hashtags.map((hashtag) => (
            <HashtagRow
              key={hashtag.hashtag_id}
              hashtag={hashtag}
              hashtagUsageCeiling={hashtagUsageCeiling}
              onFollow={onFollow}
              onMute={onMute}
              onBlock={onBlock}
              onRemoveForceFollow={onRemoveForceFollow}
            />
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default HashtagTable;
